import { data } from '../../svg/LinkOff/data';
import { makeIcon } from '../makeIcon';

export const LinkOff = makeIcon(data, 'link_off', 'LinkOff');

export default LinkOff;
